import PropTypes from 'prop-types'
import React from 'react'

import Cost, { CostPreloader } from 'components/Cost'

import {
  CrossedCostBlock,
  CostBlock,
  MutedCostBox,
  DiscountLabelNewStyled,
  PriceWrapper,
} from './styles'

/**
 * CartCostBlock
 *
 * @param {object} props - properties of component
 * @returns {node} CartCostBlock
 */
const CartCostBlockNew = props => {
  const {
    intlCode,
    currencyCode,
    dictCart,
    discount,
    realCost,
    cost,
    isLoading,
    showDiscount,
    showCrossedCost,
    precision,
    size,
    inRow,
  } = props
  return (
    <>
      <PriceWrapper inRow={inRow}>
        {showCrossedCost && (
          <CrossedCostBlock>
            <MutedCostBox>
              {isLoading ? (
                <CostPreloader className="mr-lg-1" size={size} />
              ) : (
                <Cost
                  className="mr-lg-1"
                  value={realCost}
                  intlCode={intlCode}
                  currency={currencyCode}
                  size={size}
                  strikethrough={true}
                  precision={precision}
                />
              )}
            </MutedCostBox>
          </CrossedCostBlock>
        )}
        <CostBlock>
          {isLoading ? (
            <CostPreloader size={size} />
          ) : (
            <Cost
              value={cost}
              intlCode={intlCode}
              currency={currencyCode}
              size={size}
              precision={precision}
            />
          )}
        </CostBlock>
      </PriceWrapper>
      {showDiscount && dictCart && !!discount && !isLoading && (
        <DiscountLabelNewStyled
          text={dictCart.labels.discount}
          isWithFilling={true}
          isWithoutShift={true}
          value={discount}
        />
      )}
    </>
  )
}

CartCostBlockNew.propTypes = {
  cost: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  intlCode: PropTypes.string.isRequired,
  realCost: PropTypes.number.isRequired,
  showCrossedCost: PropTypes.bool.isRequired,
  dictCart: PropTypes.object,
  discount: PropTypes.number,
  precision: PropTypes.number,
  showDiscount: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  inRow: PropTypes.bool,
}

CartCostBlockNew.defaultProps = {
  showDiscount: false,
  size: 'cart',
  inRow: false,
}

export default CartCostBlockNew
